import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Groups'

export const GroupsEP : EndPointConfig[] =[
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)        
        .setActionName("GetUserGroups")
]